<svg
    width="233"
    height="140"
    viewBox="0 0 233 140"
    xmlns="http://www.w3.org/2000/svg">
    <!-- Roof -->
    <svg:path
        class="outer-roof"
        d="M0 58.702L97.6265 0.416504L195.247 58.702L97.3795 117.214L0 58.702Z" />
    <svg:path
        d="M97.6265 7.92773L12.3665 58.8414L97.6265 109.961L182.9 58.8414L97.6265 7.92773Z"
        [attr.fill]="'var(--roof-bg)'" />

    <g
        [x]="-40"
        [y]="-20"
        app-roof-box></g>
</svg>
